import type { FC } from 'react';
import styles from './DeliveryCenterPanel.module.css';
import type { DeliveryCenterPanelProps } from './DeliveryCenterPanel.types';
import { getClasses } from '@/_utils/classnames';

export const DeliveryCenterPanel: FC<DeliveryCenterPanelProps> = ({
  children,
  className,
}) => {
  const panelCenterClasses: string = getClasses(styles.panelCenter, className);

  return <section className={panelCenterClasses}>{children}</section>;
};
